import BedIcon from "url:./icon-bed.png";
import BathIcon from "url:./icon-bath.png";
import CarIcon from "url:./icon-car.png";
import HouseIcon from "url:./icon-house.png";
import FilledStar from "url:./star_with_fill.png";
import Star from "url:./star_without_fill.png";
import CotalityLogo from "url:./CotalityLogo.jpeg";

export { BedIcon, BathIcon, CarIcon, HouseIcon, FilledStar, Star, CotalityLogo };
